import React from 'react';
import PropTypes from 'prop-types';

function ViewPublish({ size, stroke, ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...otherProps}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.3728 18.4897C13.5371 20.1611 12.623 20.7 12 20.7C11.912 20.7 11.8183 20.6893 11.7197 20.6661C11.2521 21.1001 10.7007 21.4958 10.0518 21.8103C10.682 21.9348 11.3334 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 12.4145 2.02522 12.8232 2.07422 13.2245C2.42803 13.0312 2.83979 12.8317 3.32228 12.6274C3.30751 12.4202 3.3 12.211 3.3 12C3.3 11.4182 3.3571 10.8498 3.46601 10.3H7.07196C7.03193 10.7675 7.00812 11.2461 7.00174 11.7333C7.43053 11.7444 7.86676 11.7915 8.30046 11.8678C8.30417 11.3304 8.33047 10.8067 8.37702 10.3L15.623 10.3C15.6733 10.8481 15.7 11.4163 15.7 12C15.7 13.0603 15.612 14.069 15.4539 15H14.4847C14.4596 15.3064 14.3934 15.6948 14.219 16.3H15.1755C14.9603 17.1229 14.6873 17.8607 14.3728 18.4897ZM9.62722 5.51031C9.15491 6.45494 8.77621 7.64512 8.54609 9.00002L15.4539 9.00002C15.2238 7.64512 14.8451 6.45494 14.3728 5.51031C13.5371 3.83886 12.623 3.3 12 3.3C11.377 3.3 10.4629 3.83886 9.62722 5.51031ZM17 12C17 11.4205 16.9754 10.8525 16.928 10.3H20.534C20.6429 10.8498 20.7 11.4182 20.7 12C20.7 13.0543 20.5125 14.0648 20.1689 15H16.7711C16.9198 14.053 17 13.0452 17 12ZM16.7711 9.00002L20.1689 9.00002C19.2715 6.55711 17.3095 4.62833 14.8453 3.77591C15.7481 5.02761 16.4348 6.85861 16.7711 9.00002ZM3.83108 9.00002L7.2289 9.00002C7.56518 6.85861 8.25194 5.02761 9.15472 3.77591C6.69045 4.62833 4.72849 6.55711 3.83108 9.00002ZM16.5154 16.3C16.1382 17.8817 15.5593 19.2341 14.8453 20.2241C16.8535 19.5294 18.528 18.12 19.5648 16.3H16.5154Z"
        fill={stroke}
      />
      <path
        d="M1.97669 17.216C1.91327 17.1376 1.85621 17.0652 1.80586 17C1.85621 16.9348 1.91327 16.8624 1.97669 16.784C2.26608 16.4266 2.68388 15.9513 3.1977 15.4781C4.24856 14.5103 5.59354 13.65 7 13.65C8.40646 13.65 9.75144 14.5103 10.8023 15.4781C11.3161 15.9513 11.7339 16.4266 12.0233 16.784C12.0867 16.8624 12.1438 16.9348 12.1941 17C12.1438 17.0652 12.0867 17.1376 12.0233 17.216C11.7339 17.5734 11.3161 18.0487 10.8023 18.5219C9.75144 19.4897 8.40646 20.35 7 20.35C5.59354 20.35 4.24856 19.4897 3.1977 18.5219C2.68388 18.0487 2.26608 17.5734 1.97669 17.216Z"
        stroke={stroke}
        strokeWidth="1"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 17.7C7.3866 17.7 7.7 17.3866 7.7 17C7.7 16.6134 7.3866 16.3 7 16.3C6.6134 16.3 6.3 16.6134 6.3 17C6.3 17.3866 6.6134 17.7 7 17.7ZM7 19C8.10457 19 9 18.1046 9 17C9 15.8954 8.10457 15 7 15C5.89543 15 5 15.8954 5 17C5 18.1046 5.89543 19 7 19Z"
        fill={stroke}
      />
    </svg>
  );
}

ViewPublish.propTypes = {
  stroke: PropTypes.string.isRequired,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  strokeWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default ViewPublish;
